<template>
    <div class="loginWrap">
        <div class="myIcon" @click="openLogin">
            <font-awesome-icon class="icon" icon="user"/>
        </div>
        <form>
            <h3>Change password</h3>
            <input :class="{redOutline: errorMessage}" @click="errorMessage=false" v-model="user.email" type="email"
                   placeholder="E-mail">
            <input :class="{redOutline: errorMessage}" @click="errorMessage=false" v-model="user.oldPassword"
                   type="password" placeholder="Old password">
            <input :class="{redOutline: errorMessage}" @click="errorMessage=false" v-model="user.newPassword"
                   type="password" placeholder="New Password">
            <input :class="{redOutline: errorMessage}" @click="errorMessage=false" v-model="passCheck" type="password"
                   placeholder="Repeat password">
            <input class="form-input" @click.prevent="checkPasswords" value="Register" type="submit">
        </form>
    </div>
</template>

<script>
    import services from "../../services/services";

    export default {
        name: "Register",
        data() {
            return {
                user: {
                    email: '',
                    oldPassword: '',
                    newPassword: '',
                },
                passCheck: '',
                errorMessage: false,
                loading: false,
            }
        },
        methods: {
            trimInputs() {
                this.user.email.trim();
                this.user.oldPassword.trim();
                this.user.newPassword.trim();
            },
            changeUserPassword() {
                services.changePassword(this.user).then(response => {
                    this.loading = true;
                    if (response.status === 200) {
                        this.loading = false;
                        this.$swal("All good!", "Password successfully changed!", "success");
                        this.openLogin();
                    } else {
                        this.loading = false;
                        this.$swal("Error", response, "error");
                    }
                });
            },
            clearErrorMessage() {
                this.user.oldPassword = '';
                this.user.newPassword = '';
                this.passCheck = '';
            },
            openLogin() {
                this.$emit('openLogin');
            },
            checkPasswords() {
                this.trimInputs();
                if (this.user.email && this.user.oldPassword && this.user.newPassword) {
                    if (this.passCheck !== this.user.newPassword) {
                        this.$swal("Hups!", "Passwords do not match", "warning");
                        return;
                    } else {
                        this.changeUserPassword();
                    }
                } else {
                    this.errorMessage = true;
                    this.openWarningAlert();
                }
            },
            openWarningAlert() {
                return this.$swal({
                    title: "Hups!",
                    text: "Seems like some fields are not filled in",
                    icon: "warning",
                    buttons: {confirm: true}
                }).then(this.clearErrorMessage);
            }

        },
    }
</script>

<style scoped>

</style>